"use strict"

/**
 *	----------------------------------------------------------------------------------------------
 *	Imports
 * 	----------------------------------------------------------------------------------------------
 */
import { tag, template, useShadow } from "slim-js/Decorators";
import { Slim } from "slim-js";

import TEMPLATE_HTML from './docsLayout.template.html';
import TEMPLATE_CSS from './docsLayout.styles.scss';

import "../../components/sidebar/sidebar.controller";
import "../../components/header/header.controller"; 

/**
 *	----------------------------------------------------------------------------------------------
 *	Class HeaderComponent - Module
 * 	----------------------------------------------------------------------------------------------
 */
@tag('app-docs-layout')
@template(`<style>${TEMPLATE_CSS}</style>${TEMPLATE_HTML}`)
@useShadow(false)
class AppDocsLayout extends Slim {

    constructor(ready){
		super();
		this.onRender = ready;
	}
}

export { AppDocsLayout };